import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const certificateUpcomingExpirationTemplates = [
  {
    id: '-233001',
    language: Language.EN,
    subject: 'Certificate expiring soon',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>The certificate {{certificateName}} for {{getBuildingNames buildings}} will expire on {{expirationDate}} (in {{remainingDays}} days).</p>
        <p>Please renew it before the expiration date.</p>
        `,
  },
  {
    id: '-233002',
    language: Language.FR,
    subject: 'Certificat bientôt expiré',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Le certificat {{certificateName}} pour {{getBuildingNames buildings}} expirera le {{expirationDate}} (dans {{remainingDays}} jours).</p>
        <p>Veuillez le renouveler avant la date d'expiration.</p>
        `,
  },
  {
    id: '-233003',
    language: Language.NL,
    subject: 'Certificaat verloopt binnenkort',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Het certificaat {{certificateName}} voor {{getBuildingNames buildings}} verloopt op {{expirationDate}} (over {{remainingDays}} dagen).</p>
        <p>Gelieve het vóór de vervaldatum te vernieuwen.</p>
        `,
  },
  {
    id: '-233004',
    language: Language.DE,
    subject: 'Zertifikat läuft bald ab',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Das Zertifikat {{certificateName}} für {{getBuildingNames buildings}} läuft am {{expirationDate}} ab (in {{remainingDays}} Tagen).</p>
        <p>Bitte erneuern Sie es vor dem Ablaufdatum.</p>
        `,
  },
];
